
import { Component, Prop, Vue } from 'vue-property-decorator';

export enum PillColor {
  PRIMARY = 'primary',
  CYAN = 'cyan',
  RED = 'red',
  GREEN = 'green',
  PURPLE = 'purple',
  PRIMARY_SLIGHTLY_DARKER = 'primary-slightly-darker',
  PRIMARY_WHITE = 'primary-white',
  GREY = 'grey',
}

@Component
export default class Pill extends Vue {

  @Prop({ type: String, required: true })
  readonly text!: string;

  @Prop({ type: String, required: true })
  readonly color!: PillColor;

  get colorClass(): string {
    return `pill-${this.color}`;
  }

}
